// This hook is to align global location for native
// Native will hit web view URL with `provinceFromNative` and `cityFromNative` query params
// Then, the useNativeGlobalLocation hook will process the data, save to local storage, and redux store

import { useEffect } from 'react';
import useIsNativeView from './useIsNativeView';
import { getProvince, getCity, updateLocation } from 'ui/services/geolocation';
import { useDispatch } from 'react-redux';
import { setGeoLocationValue } from 'ui/store/geolocation/actions';
import { useRouter } from './useCustomRouter';
import { DEFAULT_LOCATION } from '../constants/defaultLocation';

const useNativeGlobalLocation = () => {
  const router = useRouter();
  const dispatch = useDispatch();
  const isNativeView = useIsNativeView();

  useEffect(() => {
    if (isNativeView) {
      const provinceFromNative = router.query?.provinceFromNative
        ? router.query.provinceFromNative
        : DEFAULT_LOCATION.provinceIsocode; // default to DKI Jakarta
      const cityFromNative = router.query?.cityFromNative
        ? router.query.cityFromNative
        : DEFAULT_LOCATION.cityIsocode; // default to Jakarta Pusat

      // Save province and city with data on query params
      saveProvinceAndCity(provinceFromNative, cityFromNative);
    }

    return;
  }, [isNativeView]);

  const saveProvinceAndCity = async (provinceCode, cityCode) => {
    const provinceList = await getProvinceList();

    const selectedProvince = provinceList.find((prov) => prov.value === provinceCode);

    const cityList = await getCityList(selectedProvince.value);

    const selectedCity = cityList.find((city) => city.value === cityCode);

    // Save to local storage
    localStorage.setItem('province_iso', selectedProvince.value);
    localStorage.setItem('city_iso', selectedCity.value);
    localStorage.setItem('city_name', selectedCity.name);

    await updateLocation({ city_name: selectedCity.name, city_iso: selectedCity.value });

    // Dispatch action to geolocation store
    const locationData = {
      province: selectedProvince.name,
      isocode: selectedProvince.value,
      city: selectedCity.name,
      cityIso: selectedCity.value,
      allCity: cityList,
    };
    dispatch(setGeoLocationValue(locationData));
  };

  const getProvinceList = async () => {
    const res = await getProvince();

    if (res.status === 200) {
      const provinceList = res.data.map((item) => ({
        value: item.isocode,
        name: item.name,
      }));

      return provinceList;
    }
  };

  const getCityList = async (provinceCode) => {
    const res = await getCity(provinceCode);

    if (res.status === 200) {
      const cityList = res.data.map((item) => ({
        value: item.isocode,
        name: item.name,
      }));

      return cityList;
    }
  };
};

export default useNativeGlobalLocation;
